export default "__VITE_ASSET__729a7429__"